module.exports = __webpack_public_path__ + "std/img/raffle-list-title.9a38622.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/raffle-list-title.png
// module id = AWVl
// module chunks = 0 5